var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var MONO_FONT = "'SF Mono', 'Cascadia Code', 'Consolas', monospace";
export var subfieldRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
};
export var subfieldCodeStyle = {
    fontFamily: MONO_FONT,
    fontWeight: 700,
    fontSize: '13px',
    color: '#1960a4',
    flexShrink: 0,
    width: '28px',
};
export var subfieldLabelStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#333',
    flexShrink: 0,
    width: '180px',
};
/**
 * The one text-input look of the form (CZNA-1572). Background and font are spelled out
 * so an input never takes them from wherever it is rendered.
 */
export var subfieldInputStyle = {
    flex: 1,
    padding: '6px 10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#fff',
    fontFamily: 'inherit',
    fontSize: '14px',
    lineHeight: '1.4',
};
/**
 * CZNA-1614 — an icon at the right end INSIDE the input box (the "open at source" link of
 * a 024 identifier), the way the "ze slovníku" badge sits in 670 $b (CZNA-1572): the
 * actions slot only has room for two icon buttons, and an input beside a third one would
 * end short of every other input of the form. The box takes the input's place in the row;
 * the input inside it reserves the room ({@link subfieldInputAdornedStyle}) so a long value
 * ends before the icon instead of running under it.
 */
export var subfieldInputBoxStyle = {
    position: 'relative',
    flex: 1,
    display: 'flex',
    minWidth: 0,
};
/** Applied on top of the input's own style when it sits in {@link subfieldInputBoxStyle}. */
export var subfieldInputAdornedStyle = {
    minWidth: 0,
    paddingRight: '36px',
};
export var subfieldInputAdornmentStyle = {
    position: 'absolute',
    top: '50%',
    right: '4px',
    transform: 'translateY(-50%)',
    display: 'flex',
};
/**
 * A value the cataloguer cannot type into (computed, derived, linked, carried): the same
 * box as an input, grey so it says so (CZNA-1572).
 */
export var subfieldReadOnlyInputStyle = __assign(__assign({}, subfieldInputStyle), { backgroundColor: '#f5f5f5', color: '#666' });
/**
 * The icon buttons right of an input (✕, lupa, odebrat řádek), in a slot of fixed width
 * so every input ends at the same right edge whatever it carries (CZNA-1572). Room for
 * two icon buttons; pushed right. The lupa is always last, so it stays put whether or
 * not a ✕ shows beside it. A row with nothing to offer still renders the slot, empty.
 */
export var subfieldActionsStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
    flexShrink: 0,
    width: '72px',
};
/** A link-looking button under the input: a secondary action, not a form submit. */
export var subfieldLinkButtonStyle = {
    alignSelf: 'flex-start',
    padding: '2px 0',
    border: 0,
    background: 'none',
    color: '#1960a4',
    fontSize: '13px',
    cursor: 'pointer',
};
/**
 * Where the input column starts: code slot + gap + label + gap. For a line that belongs
 * under the inputs rather than under the whole row (CZNA-1376).
 */
export var subfieldInputColumnOffset = '224px';
